































































































































































































































































































import Vue from "vue";
import {Component, Watch, Emit, Prop} from "vue-property-decorator";
import './register.less';
import {Validations} from 'vuelidate-property-decorators';
import Stepper from "@/components/stepper/stepper.vue";
import {required, email, minValue, minLength, maxLength,numeric} from 'vuelidate/lib/validators';
import FileUpload from 'vue-upload-component'
import {submitRegisterForm} from "@/service/webclient/webclient";
import Simplemodal from "@/components/simplemodal/simplemodal.vue";
import SimpleDropdown from "@/components/simple-dropdown/simple-dropdown.vue";

@Component({
    components: {
        Stepper,
        FileUpload,
        Simplemodal,
        SimpleDropdown
    }
})
export default class register extends Vue {

    public files = [];
    public images = [];
    public currentStep = 0;
    public maxCurrentStep = 0;
    public selectStep = 0;
    public steps = [{id: 1, title: 'Személyes adatok', titleShort : 'Személyes adatok'},
        {id: 2, title: 'Projektadatok', titleShort : 'Projekt-adatok'},
        {id: 3, title: 'Dokumentumok', titleShort : 'Dokument-umok'}];

    public step0 = {
        first_name: "",
        last_name: "",
        city: "",
        zip_code: "",
        street_name: "",
        street_type: null,
        street_number: "",
        email: "",
        address: "",
        phone: ""
    };
    public step1 = {
        house_postcode: "",
        house_city: "",
        house_street_name: "",
        house_street_type: null,
        house_street_number: "",
        dealer_company_name: "",
        implementer_company_name: "",
        contributing_seller_name: ""
    };

    public disabledNextButton = false;
    public isSubmitFormSend = false;
    public startContentView = true;
    public beError = false;
    public errorsText = [];
    public enableSubmit = false;

    public step2 = {
        files: [],
        images: [],
        accept: "",
        accept2: "",
        accept3: "",
        accept4: ""
    };

    private modalData={
        title : 'Hiba történt',
        content: '',
        key: 'registrationModify'
    };

  streetTypes = [
    {title:"utca", id:"utca" },
    {title:"út", id:"út" },
    {title:"köz", id:"köz" },
    {title:"tér", id:"tér" },
    {title:"dűlő", id:"dűlő" },
    {title:"körút", id:"körút" },
    {title:"lépcső", id:"lépcső" },
    {title:"lejtő", id:"lejtő" }
  ]


   getImageSrc(file) {
      return window.URL.createObjectURL(new Blob([file.file], {type: file.type}));
    }

    uploadAllFiles() {

    }
    backUrl(){
        history.back();
    }
    backToStartContent(){
        this.startContentView = true;
        this.showSlogen();
    }
    goToForm(){
        this.startContentView = false;
        this.updateRequiredFieldsVisibility();
        this.hiddenSlogen();
    }

    backStep() {
        if (this.currentStep != 0) {
            this.currentStep--;
            this.updateRequiredFieldsVisibility();
        }
    }


    nextStep() {
        if (this.currentStep <= this.maxCurrentStep) {
            switch (this.currentStep) {
                case 0:

                    this.$v.step0.$touch();
                    setTimeout(() => {
                        if (!this.$v.step0.$invalid) {
                            this.currentStep++;
                            this.updateRequiredFieldsVisibility();
                            this.maxCurrentStep = 1;
                        }
                    }, 200);

                    break;
                case 1:

                    this.$v.step1.$touch();
                    setTimeout(() => {
                        if (!this.$v.step1.$invalid) {
                            this.currentStep++;
                            this.updateRequiredFieldsVisibility();
                            this.maxCurrentStep = 2;
                        }
                    }, 200);

                    break;
                case 2:

                    this.$refs.uploadFiles.active = true;
                    this.$refs.upload.active = true;
                    this.$v.step2.$touch();
                    setTimeout(() => {
                        if (!this.$v.step2.$invalid) {
                            this.enableSubmit = true;
                            this.submitForm();
                        }
                    }, 200);

                    break;

                default:
                    break;
            }
        }
    }

    inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                return prevent()
            }
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                return prevent()
            }
        }
    }

    inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
            // add
        }
        if (newFile && oldFile) {
            // update
        }
        if (!newFile && oldFile) {
            // remove
        }
    }

    mounted() {
      this.updateRequiredFieldsVisibility();
    }

    updateRequiredFieldsVisibility() {
      let requiredFieldsDiv = document.getElementById('required-fields-span');
      if ( requiredFieldsDiv ) {
        let visible = !this.isSubmitFormSend && !this.startContentView && this.currentStep >= 0 && this.currentStep <= 3;
        if ( visible ) {
          requiredFieldsDiv.className = 'd-block';
        } else {
          requiredFieldsDiv.className = 'd-none';
        }
      }
    }


    getServerFilesObject(files){
        let array = [];
        let obj = {original: '', unique:''};
        $.each(files, (index, value)=>{
            if(value.success == true){
                //obj.original=JSON.parse(value.response).original_filename;
                //obj.unique=JSON.parse(value.response).filename;
                array.push({
                    original: JSON.parse(value.response).original_filename,
                    unique: JSON.parse(value.response).filename
                });
            }
        });

        return array;
    }

    hiddenSlogen(){
        /*$('.nyerjen-app-slogen-block').addClass('destop-content');*/
        $('.nyerjen-app-header-block').addClass('mb-4');
        $('.nyeremenyInfo').addClass('d-none');
        $('.regInfo').removeClass('d-none');

    }

    showSlogen(){
        $('.nyerjen-app-slogen-block').removeClass('destop-content');
        $('.nyerjen-app-header-block').removeClass('mb-4');
        $('.nyeremenyInfo').removeClass('d-none');
        $('.regInfo').addClass('d-none');
        this.updateRequiredFieldsVisibility();
    }
  validatePhone(phone) {
    let regex = /(?:\+)(?:\d{1,2})(?:\ \d{1,2})(?:\ )(\d{3,4})(?:\ )?(\d{3,4})$/;
    if (!phone || phone.length == 0) {
      return true;
    } else {
      return regex.test(phone);
    }
  };
    submitForm() {
        this.$v.$touch();
        if (this.$refs.upload &&
            this.$refs.upload.uploaded &&
            this.$refs.uploadFiles &&
            this.$refs.uploadFiles.uploaded &&
            !this.$v.$invalid &&
            this.enableSubmit
        ) {
            this.beError = false;
            this.disabledNextButton = true;

            let form = {
                "first_name": this.step0.first_name,
                "last_name": this.step0.last_name,
                "phone": this.step0.phone,
                "email": this.step0.email,
                "city": this.step0.city,
                "zip_code": this.step0.zip_code,
                "street_name": this.step0.street_name,
                "street_type": this.step0.street_type.id,
                "street_number": this.step0.street_number,
                "house_postcode": this.step1.house_postcode,
                "house_city": this.step1.house_city,
                "house_street_name": this.step1.house_street_name,
                "house_street_type": this.step1.house_street_type.id,
                "house_street_number": this.step1.house_street_number,
                "dealer_company_name": this.step1.dealer_company_name,
                "implementer_company_name": this.step1.implementer_company_name,
                "contributing_seller_name": this.step1.contributing_seller_name,
                "files": this.getServerFilesObject(this.step2.files),
                "images": this.getServerFilesObject(this.step2.images),
                "accept": this.step2.accept? 1: 0,
                "accept2": this.step2.accept2? 1: 0,
                "accept3": this.step2.accept3? 1: 0,
                "accept4": this.step2.accept4? 1: 0
            };
            this.disabledNextButton = true;
            submitRegisterForm(form).then((data) => {
                this.disabledNextButton = false;
                if (data.hiba == 0) {
                    this.isSubmitFormSend = true;
                    this.showSlogen();
                } else {
                    this.beError = true;
                    this.errorsText = data.mezok;
                    this.modalData.content=this.getErrorMesage(data.mezok);
                    $('#'+this.modalData.key).modal('show');
                }
            })
        } else {
          console.log(this.$v);
        }
    }


    @Watch("step2", {immediate: true, deep: true})
    watchRefs(step2) {
        if (typeof step2 != "undefined") {
            if(this.enableSubmit){
                this.submitForm();
            }
        }
    }


    @Watch("selectedStep", {immediate: true, deep: true})
    onSelectStep(stepID) {
        if (typeof stepID != "undefined")
            this.currentStep = stepID;
    }

    getErrorMesage(datas){
        let text = "";
        $.each(datas, (index, value)=>{
            if(value.hibas == 1){
                text += value.hiba_szoveg;
            }
        })

        return text;
    }

    @Validations()
    validations = {
        step0: {
            first_name: {required, minLength: minLength(2)},
            last_name: {required, minLength: minLength(2)},
            city: {required, minLength: minLength(2)},
            zip_code: {required, minLength: minLength(4), numeric},
            email: {required, email},
            street_name: {required, minLength: minLength(1)},
            street_type: {required},
            street_number: {required, minLength: minLength(1)},
            phone: {validatePhone: this.validatePhone, required},
        },
        step1: {
            house_postcode: {required, minLength: minLength(4),numeric},
            house_city: {required, minLength: minLength(2)},
            house_street_name: {required, minLength: minLength(2)},
            house_street_type: {required},
            house_street_number: {required, minLength: minLength(1)},
            dealer_company_name: {required, minLength: minLength(3)},
            implementer_company_name: {minLength: minLength(0)},
            contributing_seller_name: {}
        },
        step2: {
            files: {},
            images: {},
            accept: {required, maxLength: maxLength(4)},
            accept2: {required, maxLength: maxLength(4)},
            accept3: {required, maxLength: maxLength(4)},
            accept4: {}
        }
    }


}
